import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=4ac4bf04&scoped=true"
import script from "./BaseTextarea.vue?vue&type=script&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&lang=js"
import style0 from "./BaseTextarea.vue?vue&type=style&index=0&id=4ac4bf04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac4bf04",
  null
  
)

export default component.exports